import { Button, Menu, Flex, MenuButton, MenuItem, MenuList, Text } from '@chakra-ui/react';

import AddIconComponent from 'components/Icons/AddIcon';
import ArrowDropdownIconComponent from 'components/Icons/ArrowDropdownIconComponent';

interface HeaderProperties {
  onOpen: () => void;
  showAddAction?: boolean;
  onAddAction?: () => void;
}

const Header = ({ onOpen, showAddAction, onAddAction }: HeaderProperties) => {
  return (
    <Flex justifyContent='space-between' align={'flex-start'} w={'100%'}>
      <Text fontSize={'md'}>Edit your source and actions here</Text>
      <Menu closeOnSelect={true} variant='primary'>
        <MenuButton
          backgroundColor={'#5A58AB'}
          padding={'.5rem 1rem'}
          borderRadius={'sm'}
          as={Button}
          title={'Create'}
          border={'none'}
          rightIcon={<ArrowDropdownIconComponent height={12} width={12} color='white' />}
          leftIcon={<AddIconComponent style={{}} color='#62B5BA' height={16} width={16} />}
          fontSize={'md'}
          fontWeight={'400'}
          width={'fit-content'}
          height={'40px'}
        >
          {' '}
          Create
        </MenuButton>

        <MenuList>
          <MenuItem onClick={onOpen}>Source</MenuItem>
          {showAddAction && onAddAction && <MenuItem onClick={onAddAction}>Action</MenuItem>}
        </MenuList>
      </Menu>
    </Flex>
  );
};

export default Header;
